import { Injectable } from '@angular/core';
import { Router, 
         CanActivate, 
         CanDeactivate,
         ActivatedRouteSnapshot
         } from '@angular/router';
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';
import { idLocale } from 'ngx-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private navigation: NavigationService ) { }
  canActivate(route: ActivatedRouteSnapshot): boolean {
    //get user token here if user token is not available return false and navigate to login
    //otherwise return true;
    
    if(localStorage.getItem("token"))
    {
      
      if(this.getLoginAndSignInRoute(route))
      {
        this.navigation.navigateTo('dashboard');
      }
      return true;
      
    }
    
   else if (!localStorage.getItem("token")) {
    if(this.getOpenLockRoute(route))
    {
      this.navigation.navigateTo('/login','','?id='+route.params.id);
    }
    else if(this.getLoginAndSignInRoute(route))
    {
      return true;
    }else {
      this.navigation.navigateTo('');
      return true;
    }
   
    }
    return false;
  }
 

  retriveRoute(route)
  {
    return route.routeConfig.path;
  }
  getOpenLockRoute(route){
    if( this.retriveRoute(route) === 'open-lock/:id'){
      return true;
    }
    return false;
  }
  getLoginAndSignInRoute(route)
  {
   
    if( this.retriveRoute(route) === 'login' || this.retriveRoute(route) === 'signin' )
    {
      return true;
    }
    
    return false;
  }
}


